export const flagChooseRecipesOnboardingRefactor =
  'flag-choose-recipes-refactor-onboarding'

export const expCancellationForm = 'exp-cancellation-flow'

export const expRestoreSkippedDeliveries = 'exp-restore-skipped-deliveries'

export const expHomepageHeroImage = 'exp-homepage-hero-image'

export const flagV2LeadContacts = 'flag-v2-lead-contact-endpoint'
